export default "__VITE_ASSET__CeBz3xSF__"